import { EntityConnectionTypeDetailsFragment } from 'generated/graphql';
import { startCase } from 'lodash-es';

interface ConnectionTypeArgument { entityType1: { namePlural: string }; entityType2: { namePlural: string } };

export const connectionTypeName =
  (connectionType: ConnectionTypeArgument) =>
    `${startCase(connectionType.entityType1.namePlural)} + ${startCase(connectionType.entityType2.namePlural)}`;
